import { atom } from 'recoil';

export type LicenseFormState = {
  name?: string;
  issuer?: string;
  licenseIssuerId?: string;
};

export const licenseFormStateAtom = atom<LicenseFormState>({
  key: 'license_form_state',
  default: {
    name: undefined,
    licenseIssuerId: undefined,
    issuer: undefined
  }
});

export type EducationFormState = {
  name?: string;
  institution?: string;
  educationIssuerClassId?: string;
};

export const educationFormStateAtom = atom<EducationFormState>({
  key: 'education_form_state',
  default: {
    name: undefined,
    institution: undefined,
    educationIssuerClassId: undefined
  }
});
